import React, { Component } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  Button
} from "reactstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import Constants from "../variables/Constants";
import Notification from "components/Notification";
import Loader from "components/Loader";
class PopUpModel extends Component {
  state = {
    OfferControl: [],
    notifyStatus: false,
    status: "",
    notifyDelete: false,
    delLoader: 0,
    active: 1,
    btnIdArray: []
  };

  componentDidMount() {
    let btnIdArray = [];
    axios.get(Constants.getUrls.model).then(resp => {
      console.log(resp.data);
      for (let i = 1; i <= resp.data.last_page; i++) {
        btnIdArray.push(i);
      }
      this.setState({
        OfferControl: resp.data.data,
        btnIdArray
      });
    });
  }
  nextPageUrl = btnId => {
    let commonUrl = "https://core.vpaedu.com/api/getpoupmodel?page=";
    axios.get(commonUrl + btnId).then(resp => {
      console.log(resp.data);
      this.setState({
        OfferControl: resp.data.data,
        active: btnId
      });
    });
  };
  handleDelete = id => {
    this.setState({ delLoader: id });
    axios
      .post("https://core.vpaedu.com/api/popupmodel/delete/" + id)
      .then(res => {
        console.log(res);
        this.setState({
          notifyDelete: true
        });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      });
  };
  handleSelect = (e, id) => {
    this.setState(
      {
        [e.target.name]: e.target.value
      },
      () => {
        const payload = {
          status: this.state.status
        };
        axios.post(Constants.postUrls.offerStatus + id, payload).then(res => {
          console.log(res);
          this.setState({
            notifyStatus: true
          });
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        });
      }
    );
  };
  render() {
    return (
      <>
        <div className="content">
          {this.state.notifyStatus ? (
            <Notification
              title={"Status Changed Successfully"}
              duration={1500}
            />
          ) : null}
          {this.state.notifyDelete ? (
            <Notification title={"Deleted Successfully"} duration={1500} />
          ) : null}
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">Popup Model Table</CardTitle>
                  <Link to="/admin/addmodel">
                    <Button className="" color="primary">
                      Add Popup Model
                    </Button>
                  </Link>
                </CardHeader>
                <CardBody>
                  <Table responsive>
                    <thead className="text-primary">
                      <tr>
                        <th>Sr.No</th>
                        <th>Title</th>
                        <th>Image</th>
                        {/* <th>Status</th> */}
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.OfferControl.map((OfferControl, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{OfferControl.title}</td>
                          <td>
                            <img
                              alt=""
                              width="80px"
                              src={Constants.imgUrl + OfferControl.img}
                            />
                          </td>
                          {/* <td>
                            <select
                              className="btn-round btn-warning selectStyling"
                              name="status"
                              value={OfferControl.status}
                              onChange={e =>
                                this.handleSelect(e, OfferControl.id)
                              }
                            >
                              <option value="enabled">Enabled</option>
                              <option value="disabled">Disabled</option>
                            </select>
                          </td> */}
                          <td>
                            <Link
                              to={{
                                pathname:
                                  "/admin/updatemodel/" + OfferControl.id,
                                state: { OfferControlData: OfferControl }
                              }}
                            >
                              <Button
                                className="btn-round"
                                color="primary"
                                type="submit"
                              >
                                Update
                              </Button>
                            </Link>
                            <Button
                              className="btn-round"
                              color="danger"
                              type="submit"
                              style={{ marginLeft: "10px" }}
                              onClick={() => {
                                this.handleDelete(OfferControl.id);
                              }}
                            >
                              {this.state.delLoader == OfferControl.id ? (
                                "Deleting..."
                              ) : (
                                "Delete"
                              )}
                            </Button>
                          </td>
                          {/* <td>
                            <Button
                              className="btn-round"
                              color="primary"
                              type="submit"
                            >
                              Delete
                            </Button>
                          </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  {this.state.OfferControl.length === 0 ? (
                    <div>
                      <h6 style={{ textAlign: "center" }}>No Data Found</h6>
                    </div>
                  ) : null}
                  <div style={{ float: "right" }}>
                    {this.state.btnIdArray.map((btnId, index) => (
                      <button
                        style={{
                          backgroundColor:
                            this.state.active === index + 1
                              ? "#C0392B"
                              : "skyblue",
                          color: "white",
                          border: "none",
                          margin: "8px 2px",
                          padding: "4px 12px",
                          fontWeight: "bold"
                        }}
                        key={index}
                        onClick={() => {
                          this.nextPageUrl(btnId);
                        }}
                      >
                        {btnId}
                      </button>
                    ))}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

export default PopUpModel;
